module.exports = __webpack_public_path__ + "img/resource.fd37aa5.svg";